module.exports = __webpack_public_path__ + "static/media/icon-bottom-account.3093688b.svg";